import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Api } from './api';
import { ObservationType } from '../models/models';

@Injectable()
export class ObservationTypesService {
  endpoint: string = 'observationTypes';

  constructor(private api: Api) {

  }

  public getObservationTypes(): Observable<ObservationType[]> {
    return this.api.get(this.endpoint)
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }

  public getObservationTypesLastUpdate(): Observable<string> {
    return this.api.get(this.endpoint + '/maxDate')
      .map(res => res.text() ? res.json() : null)
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }

}



// WEBPACK FOOTER //
// ./src/app/core/observation-types.service.ts